import React, { useEffect } from 'react';
import './Loader.css'; // Importa lo stile

const Loader = () => {

    return (
        <div className="loader-overlay hover:cursor-wait">
            <div className="loader-logo animate-bounce"></div>
        </div>
    );
};

export default Loader;